import React, { useState } from "react";
import styled from "styled-components";
import Navbaartesting from "../components/Navbaartesting";
import Footer from "../components/Footer";
import CareerImg from "../school_images/career.png";
import CareerMainImg from "../school_images/career_main_image.jfif";
import { FaFacebook } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoLinkedin } from "react-icons/io5";
import { Link } from "react-router-dom";

const Career = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    file: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "file" ? files[0] : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Add your logic to handle form submission here, such as sending data to a server.

    // For demonstration purposes, log the form data to the console.
    console.log(formData);
  };
  return (
    <div>
      <Navbaartesting />
      <MainImageDiv>
        <img src={CareerMainImg} alt="Career_image" className="w-full" />
        <SocialMediaIconsDiv>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.facebook.com/gdgoenkadarbhanga/"
              target="_blank"
            >
              <FaFacebook />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.youtube.com/channel/UCyG9n-Bbb75mEgQ5FWLtggg"
              target="_blank"
            >
              <IoLogoYoutube />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.instagram.com/gdgoenkadarbhanga"
              target="_blank"
            >
              <FaInstagramSquare />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3 ">
            <Link
              to="https://www.linkedin.com/in/gd-goenka-darbhanga-b88430217"
              target="_blank"
            >
              <IoLogoLinkedin />
            </Link>
          </div>
        </SocialMediaIconsDiv>
        <MainHeading className=" font-bold pt-10 px-10 uppercase  absolute ">
          Career @ GDGPS
        </MainHeading>
      </MainImageDiv>

      <h1 className="text-[5vw] font-bold mb-4 mt-4 text-green-900 font-serif">
        CAREER
      </h1>

      <CareerForm>
        <form onSubmit={handleSubmit}>
          <Div className="flex justify-between ">
            <Div1>
              <label>Name of Candidate*:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Div1>

            <Div1>
              <label>Date of Birth*:</label>
              <input
                type="date"
                name="DateOfBirth"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Div1>
          </Div>

          <Div className="flex justify-between">
            <Div1>
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Div1>
            <Div1>
              <label>Phone Number:</label>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>
          </Div>

          <Div className="flex justify-between ">
            <Div1>
              <label>Total No. of experience</label>
              <input
                type="text"
                name="experience"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>

            <Div1>
              <label>Name of Last Organization and Years</label>
              <input
                type="text"
                name="lastOrganization"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>
          </Div>

          <Div className="flex justify-between">
            <Div1>
              <label>Position Applied </label>
              <input
                type="text"
                name="lastOrganization"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>

            <Div1>
              <label>Present Pay / Last Salary Drawn* </label>
              <input
                type="text"
                name="lastOrganization"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>
          </Div>

          <Div className="flex justify-between">
            <Div1>
              <label>Minimum Salary Acceptable* </label>
              <input
                type="text"
                name="lastOrganization"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>

            <Div1>
              <label>Notice Period Required for Joining* </label>
              <input
                type="text"
                name="lastOrganization"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </Div1>
          </Div>

          <Div className="flex justify-between">
            <Div1>
              <label>Upload PDF/Word File:</label>
              <input
                type="file"
                name="file"
                onChange={handleChange}
                accept=".pdf, .doc, .docx"
              />
            </Div1>
            <Div1>
              <label>Address</label>
              <input type="text" name="address" onChange={handleChange} />
            </Div1>
          </Div>
          <button type="submit" className="mt-6 mb-4">
            Submit
          </button>
        </form>
      </CareerForm>
      <Footer />
    </div>
  );
};

export default Career;

const Div = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const CareerForm = styled.div`
  padding: 0 7%;
  width: 100vw;
  margin-bottom: 1rem;
  button {
    padding: 5px 20px;
    background-color: #2c975b;
    color: white;
    font-size: 20px;
    border-radius: 5px;
    &:hover {
      background-color: #ff0000;
    }
  }
`;

const Div1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 600px;
  margin-bottom: 1%;
  label {
    font-size: 1.3rem;
    opacity: 0.8;
  }
  input {
    width: 100%;
    border: 2px solid #ccc;
    padding: 10px;
  }
`;

const MainHeading = styled.span`
  position: absolute;
  bottom: 10%;
  right: 10%;
  color: #2c975b;
  font-size: 50px;
  @media (max-width: 640px) {
    font-size: 30px;
  }
`;

const MainImageDiv = styled.div`
  padding: 0 0%;
  max-height: 500px;
  position: relative;
  min-height: 300px;
  img {
    max-height: 500px;
    height: 100%;
    width: 100%;
    min-height: 300px;
  }
`;

const SocialMediaIconsDiv = styled.span`
  color: #fff;
  position: absolute;
  top: 20%;
  right: 2%;
  a {
    color: #fff;
    font-size: 30px;
    &:hover {
      color: brown;
    }
  }
  div {
    @media (max-width: 640px) {
      font-size: 25px;
      width: 45px;
      height: 45px;
    }
  }
`;
